/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Alpha_SearchInputs */

const en_landing_capability_alpha_search = /** @type {(inputs: Landing_Capability_Alpha_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search your research library`)
};

/**
* | output |
* | --- |
* | "Search your research library" |
*
* @param {Landing_Capability_Alpha_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_alpha_search = /** @type {((inputs?: Landing_Capability_Alpha_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Alpha_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_alpha_search(inputs)
});